import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleMeetRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m17.838 16 2.73 3.12 3.67 2.345.64-5.446-.64-5.324-3.741 2.06z",
			fill: "#00832d"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 20.96v4.639c0 1.06.86 1.92 1.92 1.92h4.64l.96-3.507-.96-3.053L5.375 20z",
			fill: "#0066da"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.56 4.481 2 11.041l3.376.96 3.183-.96.944-3.011z",
			fill: "#e94235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.56 11.04H2v9.92h6.56z",
			fill: "#2684fc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m28.43 7.259-4.192 3.436v10.77l4.21 3.452A.96.96 0 0 0 30 24.16V8.001a.96.96 0 0 0-1.57-.742M17.838 16v4.96h-9.28v6.559h13.759c1.06 0 1.92-.86 1.92-1.92v-4.134z",
			fill: "#00ac47"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.318 4.481H8.56v6.56h9.279V16l6.399-5.302V6.401c0-1.06-.86-1.92-1.92-1.92",
			fill: "#ffba00"
		})
	]
});
export default SvgGoogleMeetRegularIcon;
